import { useContext } from "react";

// react-flatpickr components
import Flatpickr from "react-flatpickr";

// react-flatpickr styles
import "flatpickr/dist/flatpickr.css";

// Material Dashboard 2 PRO React TS components
import MDInput from "components/MDInput";

import { Japanese } from "flatpickr/dist/l10n/ja";

import { LanguageContext } from "context";

// types
interface Props {
  input?: {
    [key: string]: any;
  };
  options?: {
    [key: string]: any;
  };
  [key: string]: any;
}

function MDDatePicker({ input, options, ...rest }: Props): JSX.Element {
  const { t } = useContext(LanguageContext);

  const finalOptions = {
    locale: Japanese,
    dateFormat: "Y-m-d",
    allowInput: true,
    static: true,
    ...options,
    onReady: [
      function (selectedDates: Date[], dateStr: string, instance: any) {
        const todayButton = document.createElement("button");
        todayButton.textContent = t("FullCalendar.today");
        todayButton.className = "flatpickr-today-button";
        todayButton.style.marginTop = "8px";
        todayButton.style.padding = "4px 8px";
        todayButton.style.border = "1px solid #ccc";
        todayButton.style.borderRadius = "4px";
        todayButton.style.cursor = "pointer";
        todayButton.onclick = () => {
          instance.setDate(new Date());
          instance.close();
        };

        setTimeout(() => {
          const fpContainer = instance.calendarContainer;
          if (fpContainer && !fpContainer.querySelector(".flatpickr-today-button")) {
            fpContainer.appendChild(todayButton);
          }
        }, 0);
      },
    ],
  };

  return (
    // @ts-ignore
    <Flatpickr
      {...rest}
      options={finalOptions}
      // @ts-ignore
      render={({ defaultValue }: any, ref: any) => (
        <MDInput {...input} defaultValue={defaultValue} inputRef={ref} />
      )}
    />
  );
}

MDDatePicker.defaultProps = {
  input: {},
};

export default MDDatePicker;
